import { Component, Input, OnInit } from '@angular/core';
import { SigninService } from "../../../signin/signin.service";
import { Router } from "@angular/router";
import { Vehicule } from "../../../model/data-managemnt";
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';

@Component({
  selector: 'app-notification-body',
  templateUrl: './notification-body.component.html',
  styleUrls: ['./notification-body.component.scss'],
})
export class NotificationBodyComponent implements OnInit {


  hasChauffeur: boolean;


  @Input() notification;


  constructor(
    private signinService: SigninService,
    private router: Router,
    private workerService: RealtimeWorkerService,
  ) { }

  ngOnInit() {
    this.isHasChauffeur();

  }


  navigate() {
    this.router.navigate(['/notification-details'])
  }

  isHasChauffeur() {
    if (this.signinService.isHasChauffeurOption()) {
      return this.hasChauffeur = true;
    }
    return false;
  }
  getChauffeurName(id: any) {

    let vehicule: Vehicule[] = this.workerService.getVehicule(id)
    if (vehicule[0] && vehicule[0].driver) {
      if (vehicule[0].driver.lastName && vehicule[0].driver.firstName) {
        return vehicule[0].driver.firstName + ' ' + vehicule[0].driver.lastName
      }
      if (vehicule[0].driver.lastName && !vehicule[0].driver.firstName) {
        return vehicule[0].driver.lastName
      }
      if (!vehicule[0].driver.lastName && vehicule[0].driver.firstName) {
        return vehicule[0].driver.firstName
      }
      if (!vehicule[0].driver.lastName && !vehicule[0].driver.firstName) {
        return "-"
      }
    } else {
      return "-"
    }
    return '';
  }

}
